import { render, staticRenderFns } from "./manageZone.vue?vue&type=template&id=c542f160&scoped=true&"
import script from "./manageZone.vue?vue&type=script&lang=js&"
export * from "./manageZone.vue?vue&type=script&lang=js&"
import style0 from "./manageZone.vue?vue&type=style&index=0&id=c542f160&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c542f160",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDataTable,VDialog,VDivider,VIcon,VLayout,VSpacer})
